export enum EModeSecurisation {
	SECURISE = "SECURISE",
	PAPIER = "PAPIER",
	DEGRADE = "DEGRADE",
	SANSVITA = "SANSVITA"
}
